import { Image } from "@chakra-ui/react";
import { getFullPathEnv } from "utils/pathEnv";

export const Banner = ({ w, h }: { w: number; h: number }) => {
  const imagemInicial = getFullPathEnv(
    "REACT_APP_API",
    `api/v1/customizacao/imagem-inicial`
  );

  return (
    <Image
      w={w}
      h={h}
      src={imagemInicial}
      alt="Imagem da Home Page"
      borderRadius="2xl"
      zIndex="0"
    />
  );
};
